<template>
  <div class="home">
    <van-nav-bar @click-left="$router.back()" left-arrow>
      <template #title>
        <span>修改密码</span>
      </template>
    </van-nav-bar>
    <van-form class="formPassword">
      <van-field
        placeholder="请输入旧密码"
        v-model="oldPassword"
        type="password"
        label="旧密码"
      />
      <van-field
        placeholder="请输入新密码"
        v-model="newPassword"
        type="password"
        label="新密码"
      />
      <van-field
        placeholder="请输入新密码"
        v-model="newPassword1"
        type="password"
        label="确认密码"
      />
      <div style="margin: 16px;">
        <van-button
          @click="updatePwd"
          round
          block
          type="info"
          native-type="button"
        >
          提交
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { updatePassword } from "@/api/user.js";
export default {
  name: "ChangePassword",
  data() {
    return {
      oldPassword: "",
      newPassword: "",
      newPassword1: ""
    };
  },
  beforeDestroy() {},
  mounted() {
    this.oldPassword = "";
    this.newPassword = "";
  },

  methods: {
    ...mapMutations(["delUser"]),
    updatePwd() {
      this.$toast.allowMultiple();
      if (this.newPassword === this.newPassword1) {
        updatePassword(this.oldPassword, this.newPassword, this.newPassword1)
          .then(res => {
            this.$toast.success("密码修改成功！请重新登录！");
            this.delUser();
            setTimeout(() => {
              this.$router.replace({
                path: "/login"
              });
            }, 1500);
          })
          .catch(err => {
            this.$toast.fail(err.response.data.msg);
          });
      } else {
        this.$toast.fail("输入密码不一致");
      }
    }
  }
};
</script>
<style scoped>
.home {
  width: 100%;
  height: 100%;
  background: #eee;
}

.formPassword {
  margin-top: 47px;
}
</style>
